import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import HrmLeaveRequestTableDetail from "../../components/hrm/HrmLeaveRequestTable";
import { ILeaveRequestQuery } from "../../models/Hrm";
import { useGetLeaveRequestsByManager } from "../../query/HrmQuery";

const PersonalLeaveApproval = () => {
  const [filter, setFilter] = useState<ILeaveRequestQuery>({
    page: 1,
    limit: 10,
  });
  const navigate = useNavigate();

  const { data, isLoading } = useGetLeaveRequestsByManager(filter);

  return (
    <>
      <Space className="px-4 pt-4">
        <Button
          type="default"
          size="large"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
          className="w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-white border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600"
        >
          Quay lại
        </Button>
      </Space>
      <HrmLeaveRequestTableDetail
        data={data!}
        isHasAvatars={true}
        isLoading={isLoading}
        filter={filter}
        setFilter={setFilter}
      />
    </>
  );
};

export default PersonalLeaveApproval;
